// components/HeroSection.jsx
'use client';

import Link from 'next/link';
import CloudImage from '../CloudImage';
import Button from '../Button';

export default function HeroSection({ content }) {
  if (!content) return null;

  const { heroContent } = content;
  const { image, announcement, headline, subheadline, cta, secondaryCta } =
    heroContent;

  return (
    <section className="relative isolate overflow-hidden">
      <div className="absolute inset-0">
        <CloudImage
          publicId={image.publicId}
          alt={image.alt}
          fill
          className="object-cover object-center"
        />
        <div className="bg-secondary/50 absolute inset-0 backdrop-blur-xs" />
      </div>

      <div className="laptop:px-8 laptop:py-40 mobile:py-20 relative z-10 mx-auto max-w-7xl px-6 py-24 text-center">
        {announcement && (
          <div className="mobile:flex-col tablet:flex-row text-primary-foreground mb-4 flex items-center justify-center text-sm font-medium">
            <span>{announcement.text}</span>
            {announcement.link && (
              <Link
                href={announcement.link.href}
                className="text-primary-foreground mobile:mt-3 tablet:mt-0 tablet:ml-3 mobile:inline-block bg-primary mt-1 block rounded-sm px-1.5 py-0.5 font-semibold hover:brightness-90"
              >
                {announcement.link.label}
              </Link>
            )}
          </div>
        )}

        {headline && <h1 className="text-primary-foreground">{headline}</h1>}
        {subheadline && (
          <p className="text-primary-foreground mt-6">{subheadline}</p>
        )}

        <div className="mt-10 flex items-center justify-center gap-x-6">
          {cta && (
            <Button href={cta.href} variant={cta.variant}>
              {cta.label}
            </Button>
          )}
          {secondaryCta && (
            <Link
              href={secondaryCta.href}
              className="hover:text-primary text-sm font-semibold text-white"
            >
              {secondaryCta.label} <span aria-hidden="true">→</span>
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}
